export const DISCOVER_CREATE_CHARACTER_ARTWORK_GRADIENT_ANGLE_DEG = 155;
export const DISCOVER_CREATE_CHARACTER_ARTWORK_GRADIENT_MID_STOP = 0.55;
/**
 * Design data for the Discovery Create Character artwork cards. Colors, glyphs
 * and gradient stops are identical on every platform, so they live here; each
 * host still owns card geometry because the web and mobile designs size and
 * rotate the cards differently.
 */
export const DISCOVER_CREATE_CHARACTER_ARTWORK_CARDS = [
    {
        id: "left",
        colors: ["#7A1D3B", "#3A0A1E", "#15040A"],
        spark: "\u2665",
        initial: "A",
    },
    {
        id: "center",
        colors: ["#5C1B6E", "#220A3A", "#080214"],
        spark: "\u2736",
        initial: "B",
    },
    {
        id: "right",
        colors: ["#6E1432", "#2E0815", "#100308"],
        spark: "\u2726",
        initial: "C",
    },
];
